export default __webpack_public_path__ + "static/media/amertrad6.9eaa84a0.png";